<p-multiSelect
  [options]="items!"
  [(ngModel)]="selectedItems"
  appendTo="body"
  placeholder="Izaberite tip dokumenta"
  (onChange)="selectedItemsOnChange()"
  [formCtrlId]="formCtrlId"
></p-multiSelect>
